export default __webpack_public_path__ + "static/media/AllerBold.e8739fd7.ttf";